import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { flowRight as compose } from 'lodash';
import NavLink from '../NavLink';

import UnreadThreadsQuery from './getUnreadThreads.graphql';
import { withQuery } from '../../hoc/withGraphql';

import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';

// Locale
import messages from '../../locale/messages';
import s from './Message.css';

class Message extends Component {
  static propTypes = {
    allUnreadThreadsCount: PropTypes.shape({
      loading: PropTypes.bool.isRequired,
      getUnreadCount: PropTypes.shape({
        total: PropTypes.number.isRequired,
      }),
    }),
  };

  static defaultProps = {
    allUnreadThreadsCount: {
      loading: true,
      getUnreadCount: {
        total: 0,
      },
    },
  };

  render() {
    const { allUnreadThreadsCount: { loading, getUnreadCount }, className } = this.props;
    let count = 0;
    if (!loading && getUnreadCount != null) {
      count = getUnreadCount.total != null ? getUnreadCount.total : 0;
    }
    const isNewMessage = count > 0;

    return (
      <NavLink to="/inbox" className={className}>
        <span><FormattedMessage {...messages.messages} /></span>
        {isNewMessage && <span className={cx(s.notification, 'notificationRTL')} />}
      </NavLink>
    );
  }
}

export default compose(
  injectIntl,
  withStyles(s),
  withQuery(UnreadThreadsQuery, {
    name: 'allUnreadThreadsCount',
    options: {
      ssr: false,
      fetchPolicy: 'network-only'
    },
  }),
)(Message);
